module.exports = __webpack_public_path__ + "static/media/user.f9f26790.png";